module.exports = __webpack_public_path__ + "img/smw-library04.b647f0a3.jpg";